/*
 * @ Author: wangjiyu
 * @Date: 2019-12-11 10:48:46
 * @LastEditTime : 2019-12-18 19:12:08
 * @LastEditors  : wangjiyu
 * @Description: file content
 */
import { IPostUIState, IAction } from '../../interface';
import ActionType from '../../action/ActionType';

const uiState = {
    currentInputIndex: 0,
    currentIndex: 0,
    currentTarget: null,
    hasFocusTitle: false, // 光标是否在标题里面
    keyboradHeight: 0, // 键盘高度
    scrollTo: 0,
    emojiVisible: false,
    emojiBoxHeight: 0,
    currentMenuHeight: 55,
    emptyViewHeight: 55,
    selectionEnd: 0,
    hasInputEmoji: false, // 当前输入内容是否为emoji
    maxFile: 50, // 相册最大可选择数
    maxVideo: 1, // 可选择的视频数
    controlIconActive: {
        // 控制栏icon是否可以
        emoji: true,
        image: true,
        title: true
    }
};

const ui = (state: IPostUIState = uiState, action: IAction) => {
    switch (action.type) {
        case ActionType.PostSetCurrentInputIndex:
            return {
                ...state,
                currentInputIndex: action.payload.currentInputIndex
            };
        case ActionType.PostSetCurrentIndex:
            return {
                ...state,
                currentIndex: action.payload.currentIndex
            };
        case ActionType.PostSetCurrentTarget:
            return {
                ...state,
                currentTarget: action.payload.currentTarget
            };
        case ActionType.PostSetHasFocusTitle:
            return {
                ...state,
                hasFocusTitle: action.payload.hasFocusTitle
            };
        // 首页文章内容滚动条高度
        case ActionType.PostSetMainScrollTop:
            return {
                ...state,
                scrollTo: action.payload.scrollTo
            };
        case ActionType.setKeyboradHeight:
            return {
                ...state,
                keyboradHeight: action.payload.keyboradHeight
            };
        case ActionType.setEmojiVisible:
            return {
                ...state,
                emojiVisible: action.payload.emojiVisible
            };
        case ActionType.setEmojiBoxHeight:
            return {
                ...state,
                emojiBoxHeight: action.payload.emojiBoxHeight
            };
        case ActionType.setEmptyViewHeight:
            return {
                ...state,
                emptyViewHeight: action.payload.emptyViewHeight
            };
        case ActionType.setSelectionEnd:
            return {
                ...state,
                selectionEnd: action.payload.selectionEnd
            };
        case ActionType.setHasInputEmoji:
            return {
                ...state,
                hasInputEmoji: action.payload.hasInputEmoji
            };
        case ActionType.setMaxFile:
            return {
                ...state,
                maxFile: action.payload.maxFile
            };
        case ActionType.setMaxVideo:
            return {
                ...state,
                maxVideo: action.payload.maxVideo
            };
        case ActionType.setControlIconActive: {
            const { controlIconActive } = state;
            const oControlIconActive = action.payload.controlIconActive;
            Object.keys(controlIconActive).forEach((key: string) => {
                // @ts-ignore
                const val = oControlIconActive[key];
                if (val !== undefined) {
                    // @ts-ignore
                    controlIconActive[key] = val;
                }
            });
            return {
                ...state
            };
        }
        default:
            return state;
    }
};

export default ui;
